<script setup lang="ts">
import MockupKitsPaginatedTable from "@/kits/components/KitsPaginatedTable.vue";

definePage({
  meta: {
    auth: ["Kits.Read", "Admin.Access"],
  },
});
</script>

<template>
  <MockupKitsPaginatedTable :is-archived="false" />
</template>
